/* eslint-disable */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import { getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { getCustomStyles } from "Config/Config";

const ActionLogFilterPopup = ({
  setFilterActionStartDate = () => {},
  setFilterActionEndDate = () => {},
  setfilterActionLogUsers = () => {},
}) => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");

  const [fromDate, setfromDate] = useState("");
  const [toDate, settoDate] = useState("");
  const [dateError, setDateError] = useState("");
  const [selectedUserValue, setSelectedUserValue] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const getUserOptions = async (query = "") => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST +
        `?userstring=${query}`;

      const response = await getData(requestUrl);

      if (response.status) {
        return response.data.map((item) => ({
          value: item.value,
          label: item.label,
        }));
      }
      return [];
    } catch (error) {
      console.log(error.message);
      return [];
    }
  };

  const userSelectHandler = (val) => {
    setSelectedUserValue(val);
    setSelectedUsers(val ? val.map((item) => item.value) : []);
  };

  const searchHandler = () => {
    setDateError("");

    // Validate - at least one filter must be selected
    const hasDateFilter = fromDate !== "" || toDate !== "";
    const hasUserFilter = selectedUsers.length > 0;

    if (!hasDateFilter && !hasUserFilter) {
      setDateError(t("Please select at least a date or user to filter"));
      return;
    }

    // Validate date range
    if (fromDate !== "" && toDate !== "" && toDate < fromDate) {
      setDateError(t("To date cannot be earlier than from date"));
      return;
    }

    // ✅ Update parent state
    setFilterActionStartDate(fromDate || "");
    setFilterActionEndDate(toDate || "");
    setfilterActionLogUsers(selectedUsers.length > 0 ? selectedUsers : []);

    // Offcanvas close
    let offCanvasPopup = document.querySelector("#offcanvasActionLogFilter");
    let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
    offCanvas.hide();

    resetHandler();
  };

  const resetHandler = () => {
    setfromDate("");
    settoDate("");
    setDateError("");
    setSelectedUserValue(null);
    setSelectedUsers([]);
  };

  return (
    <div
      className="offcanvas offcanvas-end custom-offcanvas"
      tabIndex="-1"
      id="offcanvasActionLogFilter"
      aria-labelledby="offcanvasActionLogFilterLabel"
    >
      <div className="offcanvas-header bg-primary text-white">
        <h5 className="offcanvas-title">{t("Filter")}</h5>
        <button
          type="button"
          className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>

      <div className="offcanvas-body p-4">
        <form
          onSubmit={(e) => e.preventDefault()}
          className="d-flex flex-column h-100"
        >
          {/* Date Filter */}
          <div className="form-group mb-4">
            <label className="d-block fs-sm fw-semibold mb-2">
              <h3>{t("Dates")}</h3>
            </label>
            <div className="row gx-2">
              <div className="col-lg-6 mb-3 mb-lg-0">
                <input
                  type="date"
                  className="form-control fs-sm shadow-none border-primary"
                  placeholder={t("From date")}
                  value={fromDate}
                  onChange={(e) => {
                    setfromDate(e.target.value);
                    setDateError("");
                  }}
                />
              </div>
              <div className="col-lg-6 mb-3 mb-lg-0">
                <input
                  type="date"
                  className="form-control fs-sm shadow-none border-primary"
                  placeholder={t("To date")}
                  value={toDate}
                  onChange={(e) => {
                    settoDate(e.target.value);
                    setDateError("");
                  }}
                />
              </div>
            </div>
            {dateError && (
              <div className="text-danger fs-sm mt-2">{dateError}</div>
            )}
          </div>

          {/* User Filter */}
          <div className="form-group mb-4">
            <label className="d-block fs-sm fw-semibold mb-2">
              <h3>{t("Select User")}</h3>
            </label>
            <AsyncSelect
              isMulti
              styles={getCustomStyles()}
              placeholder={t("Search by user name or email")}
              loadOptions={getUserOptions}
              defaultOptions={false}
              cacheOptions={false}
              value={selectedUserValue}
              onChange={userSelectHandler}
            />
          </div>
        </form>
      </div>

      <div className="offcanvas-footer bottom-0 start-0 end-0 bg-white p-3 border-top d-flex justify-content-between align-items-center">
        <button
          type="button"
          className="btn btn-primary flex-grow-1"
          onClick={searchHandler}
        >
          {t("Search")}
        </button>
      </div>
    </div>
  );
};

export default ActionLogFilterPopup;
